export function getDMDisplayName(
  participants: Array<{ userId: string; name: string }>,
  currentUserId: string,
): string {
  const others = participants.filter((p) => p.userId !== currentUserId);
  if (others.length === 0) return '나';
  if (others.length === 1) return others[0].name;
  if (others.length === 2) return `${others[0].name}, ${others[1].name}`;
  return `${others[0].name}, ${others[1].name} 외 ${others.length - 2}명`;
}
